import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import CONSTANT from "../../../constant";
import Header from "../../../component/common/Header";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { MessageBar, MessageBarType } from "@fluentui/react";
import { addDak, generateCode } from "../../../actions/DakManagement";
import { getUserSummaryList } from "../../../actions/UserAction";
import { toast } from "react-toastify";
import { TextField } from "@fluentui/react";
import { Typeahead } from "react-bootstrap-typeahead";
import { mailTypes } from "../misc/mailTypes";

function DakManagement() {
   
  const [showErrorAlert, setShowErrorAlert] = useState(false);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [description, setDescription] = useState("");
  const [awb, setAwb] = useState("");
  const [users, setUsers] = useState([]);
  const [mailCode, setMailCode ] = useState("");
  const [mailType, setMailType] = useState(null);
  const [otherMailType, setOtherMailType] = useState("");
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    getUserList();
    generateMailCode();
  }, []);

  async function generateMailCode() {
    setShowLoader(true);
    try {
       
      

      const { result } = await generateCode("inbound");
      const mailCode = `${result.type}/${result.id}`;
      setMailCode(mailCode);
    } catch (e) {
      console.log(e);
    }
    setShowLoader(false);
  }

  function onUserInput(field, value) {
    setShowErrorAlert(false);
    if (field === "from") {
      setFrom(value);
    }
    if (field === "to") {
      setTo(value);
    }
    if (field === "description") {
      setDescription(value);
    }
    if (field === "awb") {
      setAwb(value);
    }
    if (field === "mailType") {
      setMailType(value);
    }
    if (field === "otherMailType") {
      setOtherMailType(value);
    }
  }

  function areFieldsValid(payload) {
    const { from, to, description, awb, mailType } = payload;
    return (
      Number.isInteger(to) &&
      from.length > 0 &&
      description.length > 0 &&
      awb.length > 0 &&
      mailType.length > 0
    );
  }

   async function onSubmit() {
    
    setShowLoader(true);
          
     
    const payload = {
      from,
      to: to && to.code,
      description,
      awb,
      type: "inbound",
      mailCode,
      mailType,
    };
     
    if (mailType === "Other") payload.mailType = otherMailType ;
    
     try {
      if (!areFieldsValid(payload)) {
        setShowErrorAlert(true);
        setShowLoader(false);
        return;
      }
       
      await addDak(payload);
      clearFields();
      toast("Dak Created");
      generateMailCode();
    } catch (e) {
      console.log(e, "eee");
    }
    setShowLoader(false);
  }

  function clearFields() {
    setFrom("");
    setTo("");
    setDescription("");
    setAwb("");
    setMailType("");
    setOtherMailType("");
  }

  async function getUserList() {
    try {
      const { result } = await getUserSummaryList();
      setUsers(result);
    } catch (e) {
      setUsers([]);
    }
  }

  return (
    <div className="container-fluid">
      <div className="row">
        {/* <div className="col-md-2 px-0">
          <Header />
        </div> */}
        <div className="col-md-12 mt-3">
          <div
            className="col-md-12"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <h1 className="page-title">DAK Management - Inbound</h1>
            <div>
              <Link
                to={CONSTANT.component.dakManagementList.url}
                className="btn btn-block btn-sm submit-button p-2"
              >
                <i className="fa fa-list mr-2" />
                Dak List
              </Link>
            </div>
          </div>
          <div className="col-md-12 p-3" style={{ border: "1p solid red" }}>
            {showLoader ? (
              <div>
                <p>Please Wait...</p>
              </div>
            ) : (
              <form onSubmit={(e) => e.preventDefault()} className="card p-3">
                <div
                  className=""
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <p style={{ fontWeight: "bold" }} className="m-0">
                    Code: {mailCode}
                  </p>
                </div>
                <div className="mt-3">
                  
                 <TextField
                    label="From"
                    required
                    onChange={(e) => onUserInput("from", e.target.value)}
                    value={from}
                  />
                   
                </div>
                 
                <div
                  className="mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                 
                 <p style={{ fontWeight: "bold" }} className="m-0">
                    To <sup style={{ color: "red" }}>*</sup>
                  </p>
                   
                  <Typeahead 
                    label="To"
                    id="receipent"
                    placeholder="Select Receiver"
                    labelKey={(option) =>
                      `${option.name} - ${option.employeeNumber}`
                    }
                    required
                    onChange={(e) => onUserInput("to", e[0])}
                    value={to}
                    options={users}
                  />
                </div>
                
                 <div
                  className="mt-3"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <TextField
                    label="Description"
                    multiline
                    required
                    onChange={(e) => onUserInput("description", e.target.value)}
                    value={description}
                  />
                   
                </div>
                 
                <div
                  className="mt-3"
                  style={{
                    display: "flex",
                    alignItems: "flex-end",
                  }}
                >
                 
                  <Typeahead
                    className="mr-2"
                    label="Mail Type"
                    id="receipent"
                    placeholder="Select Mail type"
                    labelKey={(option) => `${option.name}`}
                    required
                    onChange={(e) => onUserInput("mailType", e[0] && e[0].name)}
                    value={mailType}
                    options={mailTypes}
                  />
                  {mailType === "Other" ? (
                    <TextField
                      label="Mail Type"
                      className="flex-1 mr-2"
                      required
                      onChange={(e) =>
                        onUserInput("otherMailType", e.target.value)
                      }
                      value={otherMailType}
                    />
                  ) : null}
                   
                  <TextField
                    label="AWB Number"
                    className="flex-1"
                    required
                    onChange={(e) => onUserInput("awb", e.target.value)}
                    value={awb}
                    disabled={!mailType}
                  />
                </div>
                <div className="col-md-12 mt-3">
                  {showErrorAlert && (
                    <MessageBar
                      delayedRender={false}
                      messageBarType={MessageBarType.error}
                    >
                      Please fill all fields
                    </MessageBar>
                  )}
                </div>
                <div
                  className="mt-3"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <PrimaryButton text="Submit" onClick={onSubmit} />
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default DakManagement;
